import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 12a2 2 0 0 0 2-2c0-.178-.03-.348-.074-.512l5.781-5.781a.999.999 0 1 0-1.414-1.414l-2.61 2.61A7.757 7.757 0 0 0 10 4C4.388 4 2.163 9.399 2.071 9.628a1.017 1.017 0 0 0 0 .744c.054.133.835 2.011 2.582 3.561l-2.36 2.36a.999.999 0 1 0 1.414 1.414l5.781-5.781c.164.043.334.074.512.074zm-4-2a4 4 0 0 1 4-4c.742 0 1.432.208 2.025.561l-1.513 1.513A2.004 2.004 0 0 0 10 8a2 2 0 0 0-2 2c0 .178.031.347.074.511l-1.513 1.514A3.959 3.959 0 0 1 6 10zm10.145-3.144l-2.252 2.252c.064.288.106.585.106.893a4 4 0 0 1-4 4 3.97 3.97 0 0 1-.89-.108l-1.682 1.68A7.903 7.903 0 0 0 10 16c5.613 0 7.837-5.399 7.928-5.629a1.004 1.004 0 0 0 0-.742c-.044-.111-.596-1.437-1.784-2.773z"
});

var SvgHideMinor = function SvgHideMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgHideMinor as S };
